export default ({ $axios, $config }, inject) => {
  const ABTastyService = {
    accessToken: null,
    tokenExpiry: 0,

    async authenticate() {
      const now = Date.now();
      if (this.accessToken && now < this.tokenExpiry) {
        return this.accessToken;
      }

      try {
        const response = await $axios.$post("/api/abtasty/token");
        this.accessToken = response.access_token;
        const expiresInMs = (response.expires_in || 3600) * 1000;
        this.tokenExpiry = now + expiresInMs - 5000;
        return this.accessToken;
      } catch (error) {
        this.$bugsnag?.notify?.(error.response || error);
      }
    },

    async request(method, endpoint, data = null, config = {}) {
      const token = await this.authenticate();

      return $axios.request({
        method,
        url: `${$config.abTastyBaseUrl}/${endpoint}`,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(config.headers || {}),
        },
        data,
        ...config,
      });
    },

    async getAllTests() {
      return await this.request(
        "GET",
        `api/core/accounts/${$config.abTastyAccountId}/tests?filter[active]=1`
      );
    },
  };

  inject("abtasty", ABTastyService);
};
